import { render } from "./RadarChart.vue?vue&type=template&id=220b5e3b&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=220b5e3b&scoped=true&lang=css"

import exportComponent from "../../../../../../vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220b5e3b"]])

export default __exports__